var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTitleLineRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 286.5,
    height: 105.21,
    viewBox: "0 0 286.5 105.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "title_line_left",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_312",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 312",
    transform: "translate(0 4.829)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_60",
    "data-name": "\\u7DDA 60",
    x1: 47.579,
    y2: 99.714,
    transform: "translate(233.463 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_61",
    "data-name": "\\u7DDA 61",
    x1: 233.463,
    transform: "translate(0 99.714)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_216",
    "data-name": "\\u9577\\u65B9\\u5F62 216",
    transform: "matrix(-0.438, 0.899, -0.899, -0.438, 286, 3.507)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTitleLineRight);
export default __webpack_public_path__ + "static/media/mobile_title_line_right.727e60197a33063affd32d65541b34e9.svg";
export { ForwardRef as ReactComponent };